import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Hook per gestire il logo della palestra dell'utente corrente
 * @returns {Object} { logoUrl, isLoading, error, refetch }
 */
export const useGymLogo = () => {
    const { currentUser, isGym, isTrainer, getAuthenticatedApi } = useAuth();
    const [logoUrl, setLogoUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchGymLogo = async () => {
        //console.log('🔍 [useGymLogo] Inizio fetchGymLogo');
        //console.log('👤 [useGymLogo] currentUser:', currentUser);
        //console.log('🏢 [useGymLogo] isGym():', isGym());
        //console.log('👨‍🏫 [useGymLogo] isTrainer():', isTrainer());
        
        // Solo per utenti gym e trainer
        if (!currentUser || (!isGym() && !isTrainer())) {
            //console.log('❌ [useGymLogo] Utente non gym/trainer, logo disabilitato');
            setLogoUrl(null);
            return;
        }

        setIsLoading(true);
        setError(null);
        //console.log('🔄 [useGymLogo] Inizio caricamento...');

        try {
            const api = getAuthenticatedApi();
            
            // Per trainer, dobbiamo prima ottenere l'ID della palestra
            let gymId = null;
            
            if (isGym()) {
                //console.log('🏢 [useGymLogo] Utente è GYM, recupero palestre...');
                // Per gym, otteniamo l'ID dalla palestra di cui è proprietario
                const response = await api.get('/gyms.php');
                
                //console.log('📡 [useGymLogo] Risposta /api/gyms.php:', response.data);
                
                if (response.data && response.data.length > 0) {
                    gymId = response.data[0].id;
                    //console.log('🏢 [useGymLogo] Gym ID trovato:', gymId);
                } else {
                    //console.log('❌ [useGymLogo] Nessuna palestra trovata per gym');
                }
            } else if (isTrainer()) {
                //console.log('👨‍🏫 [useGymLogo] Utente è TRAINER, gym_id:', currentUser.gym_id);
                // Per trainer, otteniamo l'ID dalla palestra a cui appartiene
                gymId = currentUser.gym_id;
            }

            if (!gymId) {
                //console.log('❌ [useGymLogo] Nessun gym_id disponibile');
                setLogoUrl(null);
                return;
            }

            //console.log('🔍 [useGymLogo] Recupero dettagli palestra ID:', gymId);
            // Ottieni i dati della palestra
            const gymResponse = await api.get(`/gyms.php?id=${gymId}`);

            //console.log('📡 [useGymLogo] Risposta /api/gyms.php?id:', gymResponse.data);
            //console.log('🖼️ [useGymLogo] logo_filename:', gymResponse.data?.logo_filename);

            if (gymResponse.data && gymResponse.data.logo_filename) {
                // Costruisci URL del logo con cache busting per forzare reload quando cambia
                const cacheBuster = Date.now();
                const logoUrl = `/api/serve_image.php?filename=${gymResponse.data.logo_filename}&type=logo&v=${cacheBuster}`;
                //console.log('✅ [useGymLogo] Logo URL costruito:', logoUrl);
                setLogoUrl(logoUrl);
            } else {
                //console.log('❌ [useGymLogo] Nessun logo_filename trovato');
                setLogoUrl(null);
            }

        } catch (err) {
            //console.error('❌ [useGymLogo] Errore nel recupero del logo:', err);
            setError(err.message);
            setLogoUrl(null);
        } finally {
            setIsLoading(false);
            //console.log('🏁 [useGymLogo] Caricamento completato');
        }
    };

    useEffect(() => {
        fetchGymLogo();
    }, [currentUser, isGym, isTrainer]);

    return {
        logoUrl,
        isLoading,
        error,
        refetch: fetchGymLogo
    };
};

export default useGymLogo;
